module.exports = __webpack_public_path__ + "img/tops-strikhals.29a92b39.png";